import React, { useCallback } from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"
import useMediaQuery from "hooks/useMediaQuery"

const ScrollIndicator = ({ children, className, fragment }) => {
  const isMobileNav = useMediaQuery(theme.navBreak)
	const clickHandler = useCallback(() => {
		const target = document.querySelector(`#${fragment}`)
    const header = document.querySelector(isMobileNav ? "#mobile-header" : "#sticky-header")
		const headerOffset = header ? header.getBoundingClientRect().height : 0
		target &&
			window.scrollTo({
				top:
					target.getBoundingClientRect().top +
					window.pageYOffset -
          headerOffset,
				behavior: "smooth",
			})
	}, [isMobileNav])
	return (
		<div
			css={{
				color: theme.softGray,
				textAlign: "center",
			}}
			className={className}
		>
			<div
        css={{
          ...theme.t6,
          cursor: fragment ? 'pointer' : null,
        }}
        onClick={clickHandler}
      >
				{children}
			</div>

			<svg
				css={{
					width: 23,
					margin: "18px auto 0",
          cursor: fragment ? 'pointer' : null,
					[theme.tablet]: { width: 21 },
					[theme.mobile]: { width: 19 },
				}}
				fill="none"
				viewBox="0 0 26 14"
				onClick={clickHandler}
			>
				<path
					stroke="currentColor"
					strokeLinecap="square"
					strokeWidth="2"
					d="M24 2L13 12 2 2"
				/>
			</svg>
		</div>
	)
}

ScrollIndicator.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
}

export default ScrollIndicator
